import React from 'react';

import {
  Actions as UIActions,
  Action,
  FileCopyIcon,
  FileDownloadIcon,
  StopIcon,
  EditIcon,
} from '@gogame/components';
import Permissions, { useIsAllowed } from '@gogame/permissions';

import {
  ACTION_EDIT,
  ACTION_DUPLICATE,
  ACTION_DEACTIVATE,
  ACTION_DEACTIVATE_AND_DELETE,
  ACTION_GET_REDEMPTION_REPORT,
  ACTION_PRESENT_RELATED_CREATIVES,
} from 'scenes/PromoCodes/constants';
import { PERMISSION_ACTION_CREATE_PROMOCODES } from 'scenes/PromoCodes/constants';
import { ScreenLink } from '@gogame/screens';

import {
  galleryLink,
  galleryLinkConceptsLink,
} from 'scenes/Gallery/GalleryPage/navigation';
import { FILTER_PROMO_CODES } from 'scenes/Gallery/GalleryPage/constants';
export const Actions = ({
  actions,
  onDeactivate,
  onExport,
  onDuplicate,
  onEdit,
  onEditSet,
  onGetRedemptionReport,
  data,
  isSet,
}) => {
  const isAllowedCreatePromoCode = useIsAllowed()(
    PERMISSION_ACTION_CREATE_PROMOCODES
  );
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={3}>
          {!isSet ? (
            <Action
              id={'duplicate'}
              icon={<FileCopyIcon />}
              label={'Duplicate'}
              disabled={
                !isAllowedCreatePromoCode || !isActionAllowed(ACTION_DUPLICATE)
              }
              onClick={onDuplicate}
            />
          ) : null}
          {isSet ? (
            <Action
              id={'export_set'}
              label={'Export'}
              icon={<FileDownloadIcon />}
              disabled={!isAllowedCreatePromoCode}
              onClick={onExport}
            />
          ) : null}
          <Action
            id={'deactivate'}
            icon={<StopIcon />}
            label={'Deactivate'}
            disabled={
              !isAllowedCreatePromoCode || !isActionAllowed(ACTION_DEACTIVATE)
            }
            onClick={onDeactivate}
          />
          <Action
            id={ACTION_GET_REDEMPTION_REPORT}
            label={'Export redemption report'}
            disabled={!isActionAllowed(ACTION_GET_REDEMPTION_REPORT)}
            onClick={onGetRedemptionReport}
          />
          <Action
            id={'deactivateAndRemove'}
            icon={<StopIcon />}
            label={'Deactivate and delete from users'}
            disabled={
              !isAllowedCreatePromoCode ||
              !isActionAllowed(ACTION_DEACTIVATE_AND_DELETE)
            }
            onClick={onDeactivate}
          />
          <Action
            id={'presentRelatedCreatives'}
            label={'Present related creatives'}
            disabled={!isActionAllowed(ACTION_PRESENT_RELATED_CREATIVES)}
            component={ScreenLink}
            componentProps={{
              link: galleryLinkConceptsLink,
              params: data?.id
                ? {
                    filters: {
                      [FILTER_PROMO_CODES]: [data.id],
                    },
                  }
                : null,
              target: '_blank',
            }}
            link={galleryLink}
          />
          <Action
            id={'edit'}
            icon={<EditIcon />}
            label={'Edit'}
            disabled={
              !isAllowedCreatePromoCode || !isActionAllowed(ACTION_EDIT)
            }
            onClick={isSet ? onEditSet : onEdit}
          />
        </UIActions>
      )}
    </Permissions>
  );
};
